import types from './types';

const INITIAL_STATE = {
    isFetching: false,
    isFetchingClaimsFacilities: false,

    result: [],
};

const authFacilitiesReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_FACILITIES_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_FACILITIES_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_FACILITIES_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
      };

    case types.GET_CLAIMS_FACILITIES_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingClaimsFacilities: true,
        };

    case types.GET_CLAIMS_FACILITIES_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingClaimsFacilities: false,
        };

    case types.GET_CLAIMS_FACILITIES_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingClaimsFacilities: false,
        };

    default:
      return state;
  }
};

export default authFacilitiesReducer;
